<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        config-module="102370"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.cargoType.code')">
            <auto-number-input v-model="editDialog.form.code" :min="0" style="width: 150px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.customerType.chineseName')">
            <el-input v-model="editDialog.form.chineseName" style="width: 150px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.customerType.englishName')">
            <el-input v-model="editDialog.form.englishName" style="width: 150px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.incoTerm.remark')">
            <el-input v-model="editDialog.form.remark" style="width: 150px" />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Creator')"
          >
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_User"
              :method-params="{officeId:$store.getters.currentOfficeId}"
              :default-value="editDialog.form.createdBy"
              disabled
              style="width: 150px"
              :clearable="false"
            />
          </el-form-item>
          <el-form-item :label="$t('Menu.CreateDate')">
            <el-date-picker v-model="editDialog.form.dateCreated" disabled style="width:150px;" type="date" value-format="yyyy-MM-dd" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import {
  deleteCrmCustomerType,
  getUsedCrmCustomerType,
  listCrmCustomerType,
  saveCrmCustomerType
} from '@/api/basicData/crmCustomerType'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'

export default {
  name: 'CrmCustomerType',
  components: { AutoNumberInput, cargoAdvanceSelect },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      selectTypeNames: TYPE_NAMES,
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.chineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.englishName'),
          field: 'englishName',
          width: 200
        },
        { headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'createdBy', colId: 'createdBy', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Modifier'),
          field: 'modifiedBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ModificationTime'),
          field: 'dateModified',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('baseInfo.basicData.incoTerm.remark'),
          field: 'remark',
          width: 200
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: undefined,
          chineseName: '',
          englishName: '',
          createdBy: '',
          dateCreated: '',
          remark: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const loading = getLoading()
      const params = { ...this.filter }
      listCrmCustomerType(params).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.selectedData = null
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          code: undefined,
          chineseName: '',
          englishName: '',
          createdBy: this.$store.getters.userInfo.userId,
          dateCreated: new Date(),
          remark: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_CustomerType')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_CustomerType')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CodeCanTBeEmpty'))
        return
      }
      if (!form.chineseName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChineseNameCanTBeEmpty'))
        return
      }
      if (!form.englishName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EnglishNameCanTBeEmpty'))
        return
      }
      const loading = getLoading()
      saveCrmCustomerType(form).then(res => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).catch(() => {
        this.editDialog.visible = false
        loading.close()
      }).finally(() => {
        loading.close()
        this.toQuery()
      })
    },
    async remove() {
      const selectedList = getGridSelected(this.gridOptions)
      const codeList = []
      selectedList.forEach(e => codeList.push(e.code))
      const data = { codeList: codeList, tenantId: this.tenantId }
      let usedFlag = false
      let loading = getLoading()
      await getUsedCrmCustomerType(data).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          usedFlag = true
          this.$message.warning(this.$t('CargoMsg.Cargo_CannotDeleteUsedCustomerType'))
        }
      }).finally(() => loading.close())
      if (usedFlag) {
        return
      }
      getGridSelectedIds(this.gridOptions, 'uuid').then(uuidList => {
        return this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          const data = { uuidList: uuidList }
          loading = getLoading()
          return deleteCrmCustomerType(data)
        }).catch(() => {
          return Promise.reject(this.$t('Message.DeletionCancelled'))
        })
      }).then(res => {
        if (res.ok) {
          loading.close()
          this.toQuery()
          this.$message({
            type: 'success',
            message: this.$t('Message.DeleteSucceeded')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Message.DeleteFail')
          })
        }
      }).finally(() => loading.close())
    }
  }
}
</script>

<style>
</style>
